import React from 'react'

/**
 * Empty component.
 */

export default function Empty({ empty, children }) {
  if (React.Children.count(children)) {
    return children
  }
  return empty
}